import {
  faFacebookSquare,
  faInstagram,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Col, Container, Nav, Navbar, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";

export const Footer = () => {
  const location = useLocation();

  const usePathname = () => {
    return location.pathname;
  };
  return (
    <Container fluid as="footer" className="footer">
      <Container>
        <Row>
          <Col sm="12" md="12" lg="4">
            <Navbar.Brand href="/">
              Josh Darby<p>London Sessions Drummer</p>
            </Navbar.Brand>
          </Col>
          <Col sm="12" md="12" lg="4">
            <Nav
              defaultActiveKey={usePathname}
              className="margin-left-right-auto"
            >
              <h3>Footer Menu</h3>
              <Nav.Link href="/">Home</Nav.Link>
              <Nav.Link href="/about">About</Nav.Link>
              <Nav.Link href="/contact">Contact</Nav.Link>
            </Nav>
          </Col>
          <Col sm="12" md="12" lg="4">
            <Nav
              className="nav-2 margin-left-right-auto"
              defaultActiveKey={usePathname}
            >
              <h3>Additional Menu</h3>
              <Nav.Link href="/cookies">Cookies Policy</Nav.Link>
              <Nav.Link href="/privacy">Privacy Policy</Nav.Link>
            </Nav>
          </Col>
        </Row>
        <Row>
          <hr />
          <Col sm="12" md="12" lg="4">
            <p className="copyright">
              © Copyright{" "}
              <a
                className="text-white"
                href="https://www.bobby-mcgrath.co.uk/"
                target="_blank"
                rel="noreferrer"
              >
                Bobby McGrath
              </a>
            </p>
          </Col>
          <Col sm="12" md="12" lg="4"></Col>
          <Col sm="12" md="12" lg="4">
            <Nav className="social">
              <Nav.Link
                href="https://www.instagram.com/joshdarby123/"
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon icon={faInstagram} size="2x" color="white" />
              </Nav.Link>
              <Nav.Link
                href="https://www.facebook.com/JoshDarbyDrums/"
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon
                  icon={faFacebookSquare}
                  size="2x"
                  color="white"
                />
              </Nav.Link>
              <Nav.Link
                href="https://www.youtube.com/channel/UCM1DfS2vWcyvNDEUalicFbw"
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon icon={faYoutube} size="2x" color="white" />
              </Nav.Link>
            </Nav>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};
